<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel"
           :width="660"
           class="mask long-modal top-modal"
    >
      <h3 slot="header" class="modal-header">忘记密码</h3>
      <div class="content">
        <Form :model="formData" :label-width="100" :rules="formRules" ref="formData" label-position="left">
          <FormItem label="手机号" prop="phone">
            <Input class="item-width v-middle" v-model="formData.phone"></Input>
          </FormItem>
          <FormItem label="手机验证码" prop="vcode">
            <Input class="item-width " v-model="formData.vcode" type="text" autocomplete="off"></Input>
            <!--<Input v-model="formData.vcode" type="text" v-show="false"></Input>-->
            <Button type="primary" :disabled="disable1 || !phoneValidate" @click.stop="getVcode">
              {{!disable1?'获取验证码':time}}
            </Button>
          </FormItem>
          <FormItem label="设置密码" prop="newPassword">
            <!--<Input v-model="formData.newPassword" type="password" v-show="false"></Input>-->
            <input type="password" autocomplete="new-password"
                   class="item-width v-middle ivu-input"
                   v-model="formData.newPassword"
                   @change="newPasswordChange"
            ></input>
          </FormItem>
          <FormItem label="验证密码" prop="newPassword2">
            <Input type="password" autocomplete="off" class="item-width v-middle "
                   v-model="formData.newPassword2"></Input>
          </FormItem>
        </Form>
      </div>
    </Modal>
  </div>

</template>
<script>

  // import {getImgVerifycode} from "../../api/systemmanage";
  import {forgetvcode, forgetchange} from "../../api/personal";


  export default {
    name: "",
    props: {
      n: {
        type: Number,
        default: 0
      }

    },
    watch: {
      n() {
        // this.getImgVerifycode()
        clearInterval(this.t1)
        this.disable1=false
        this.time=60
        this.clearData()
        this.isShow = true
      }
    },
    computed: {
      phoneValidate() {
        if (!this.formData || !this.formData.phone) {
          return false

        }
        let pattern = /^1\d{10}$/
        return pattern.test(this.formData.phone)

      }

    },
    data() {
      return {
        time: 60,
        disable1: false,
        // loading1:true,
        current: 0,
        loading: true,
        isShow: false,
        formData: {
          phone: '',
          vcode: '',
          // imgCode:'',
          newPassword: '',
          newPassword2: ''
        },
        formRules: {
          phone: [{required: true, validator: this.validatePhone, trigger: 'blur'}],
          vcode: [{required: true, type: 'string', message: ' ', trigger: 'blur'}],
          newPassword: [{
            required: true,
            validator: this.validatenewPassOri,
            message: '密码由不少于8位且不含有用户名信息的大写字母、小写字母、数字和特殊字符组成',
            trigger: 'blur'
          }],

          newPassword2: [{required: true, type: 'string', validator: this.validatePass, trigger: 'blur'}],
          // imgCode:[ {required: true, validator: this.validateImgcode,message:' ', trigger:'blur'} ],
        },
        formData2: {},
        formRules2: {},
        imgVerifycode: '',
        imgId: '',
        imgCode: '',
      }
    },
    methods: {
      clearData() {
        this.formData = {
          phone: '',
          vcode: '',
          // imgCode:'',
          newPassword: '',
          newPassword2: ''
        }
        this.$refs['formData'] && this.$refs['formData'].resetFields()


      },
      validatenewPassOri(require, value, callback) {
        var numasc = 0;
        var charasc = 0;
        var charaasc = 0;
        var otherasc = 0;
        let message = '密码由不少于8位且不含有用户名信息的大写字母、小写字母、数字和特殊字符组成 '
        if (0 == value.length) {
          callback(new Error(message))
        } else if (value.length < 8) {
          callback(new Error(message))
        } else {
          for (var i = 0; i < value.length; i++) {
            var asciiNumber = value.substr(i, 1).charCodeAt();
            if (asciiNumber >= 48 && asciiNumber <= 57) {
              numasc += 1;
            }
            if ((asciiNumber >= 65 && asciiNumber <= 90)) {
              charasc += 1;
            }
            if ((asciiNumber >= 97 && asciiNumber <= 122)) {
              charaasc += 1;
            }
            if ((asciiNumber >= 33 && asciiNumber <= 47) || (asciiNumber >= 58 && asciiNumber <= 64) || (asciiNumber >= 91 && asciiNumber <= 96) || (asciiNumber >= 123 && asciiNumber <= 126)) {
              otherasc += 1;
            }
          }
          if (0 == numasc) {
            callback(new Error(message))
          } else if (0 == charasc) {

            callback(new Error(message))
          } else if (0 == charaasc) {

            callback(new Error(message))
          } else if (0 == otherasc) {

            callback(new Error(message))
          } else {
            callback()
          }
        }
      },
      newPasswordChange() {
        this.formData.newPassword2 = ''

      },

      setT1() {
        this.t1 = setInterval(() => {
          if (this.time <= 1) {
            clearInterval(this.t1)
            this.disable1 = false
            this.time = 60
          }
          this.time--

        }, 1000)


      },

      getVcode() {
        let params = {
          phone: this.formData.phone
        }
        forgetvcode(params).then(res => {
          this.$Message.success('验证码下发成功')
          this.disable1 = true
          this.setT1()
        }).catch(error => {
        })
      },
      validatePhone(rules, value, callback) {
        let pattern = /^1\d{10}$/

        if (pattern.test(value)) {
          callback();
        } else {
          callback(new Error(' '));
        }

      },
      validatePass(rules, value, callback) {
        if (!(value + '')) {
          callback(new Error(' '));
        }

        if (value === this.formData.newPassword) {
          callback();
        } else {
          callback(new Error(' '));
        }

      },
      // validateImgcode(rules,value,callback){
      //   if(value===this.imgCode && this.imgCode!==''){
      //     callback()
      //   }
      //
      // },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        this.$refs['formData'].validate(bool => {
          if (bool) {
            let params = {
              phone: this.formData.phone,
              vcode: this.formData.vcode,
              newPassword: this.formData.newPassword
            }
            forgetchange(params).then(res => {
              // this.current = 1
              this.$Message.success('修改密码成功')

            }).catch(error => {

            }).finally(() => {
              this.isShow=false
            })

          }
          else {
            // this.changeLoading1()
            this.changeLoading()
          }
        })

      },
      cancel() {

      },
      getImgVerifycode() {
        getImgVerifycode().then(res => {
          if (!res.data) {
            return
          }
          this.imgVerifycode = res.data.imgData
          this.imgId = res.data.imgId
          this.imgCode = res.data.imgCode
        }).catch(error => {

        })
      }
    }

  }
</script>

<style scoped>
  .content {
    padding: 0 0 30px 30px;
  }

  .v-middle {
    vertical-align: middle;
  }

</style>
